import React from "react";
import Helmet from "react-helmet";
import CasesTableContainer from "../cases-table-container";
import { isString, without, toUpper } from "lodash";
import { keepOnlyPTABQueryStrings } from "../../../helpers/url";
import { withUser } from "@unifiedpatents/sso";

const CaseList = ({ location, router, user }) => {
  const query = keepOnlyPTABQueryStrings(location.query);
  // put extra description for SEOed query strings
  const queryKeys = without(Object.keys(query), "sort");
  let descriptionExtraValue = "";
  let descriptionExtra = "";
  // handle meta for case list filtered by case status and substatus
  if (queryKeys.length <= 2 && queryKeys.length > 0 && without(queryKeys, "up_status", "up_substatus").length === 0) {
    if (queryKeys.length === 1) {
      // there would be only a up_status field, single up_substatus field is not valid
      descriptionExtraValue = toUpper(query["up_status"]);
      descriptionExtra = ` for Status ${descriptionExtraValue}`;
    } else {
      descriptionExtraValue = `${toUpper(query["up_status"])} - ${toUpper(query["up_substatus"])}`;
      descriptionExtra = ` for Status ${descriptionExtraValue}`;
    }
  }
  // handle meta for case list filtered by one entity
  if (queryKeys.length === 1 && isString(query[queryKeys[0]])) {
    // handle only situtation when
    // - one query string is passed, and
    // - only one value is provided for the query string
    descriptionExtraValue = toUpper(query[queryKeys[0]]);
    switch (queryKeys[0]) {
      case "patent.patent_number":
        descriptionExtra = ` for Patent ${descriptionExtraValue}`;
        break;
      case "petitioners":
        descriptionExtra = ` for Petitioner ${descriptionExtraValue}`;
        break;
      case "patent_owners":
        descriptionExtra = ` for Patent Owner ${descriptionExtraValue}`;
        break;
      case "lawfirms.petitioner":
        descriptionExtra = ` for Petitioner's Counsel ${descriptionExtraValue}`;
        break;
      case "lawfirms.patent_owner":
        descriptionExtra = ` for Patent Owner's Counsel ${descriptionExtraValue}`;
        break;
      case "judges.author":
        descriptionExtra = ` for Author Judge ${descriptionExtraValue}`;
        break;
      case "judges.panel":
        descriptionExtra = ` for Panel Judge ${descriptionExtraValue}`;
        break;
    }
  }
  const helmet = {
    title: `PTAB Case List${descriptionExtra}`,
    meta: [
      {
        name: "keywords",
        content: `PTAB,Patent Trial and Appeal Board,PTAB Search,PTAB Cases,AIA Trials,IPR,CBM,PGR,${descriptionExtraValue || "PTAB Query"}`
      },
      {
        name: "description",
        content: `PTAB Cases${descriptionExtra}. Get latest and most complete PTAB case dockets. Advanced search filters built in. Free of charge.`
      }
    ]
  };
  return (
    <div>
      <Helmet {...helmet} />
      <CasesTableContainer
        queries={query}
        onQueryChange={q => {
          router.push({
            pathname: router.location.pathname,
            query: keepOnlyPTABQueryStrings(q)
          });
        }}
        shouldExport={user.status.canAccessData && user.metadata.authorization.roles.indexOf("disallow-case-export") < 0}
        size="small"
      />
    </div>
  );
}

export default withUser(CaseList);
